import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { getSection } from 'actions/sections';
import { connect } from 'react-redux';
import User from '_class/User';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { getUsersWithoutMentorGroups, updateUserPhoneNumber } from 'actions/user';
import Modal from 'containers/Modals/Modal';
import UserPhoneForm from 'containers/Forms/UserPhone';
import { Expandable, Spinner } from 'UI';
import { Search } from 'UI/Inputs';
import { BlockContent } from 'UI/Elements/Block';
import { Checkbox, Icon, translate } from '@haldor/ui';
import './UserSelect.scss';

var UserSelect = /*#__PURE__*/function (_Component) {
  _inherits(UserSelect, _Component);

  var _super = _createSuper(UserSelect);

  function UserSelect(props) {
    var _this;

    _classCallCheck(this, UserSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.input != null && _this.props.input.onChange != null && typeof _this.props.input.onChange == 'function') {
        _this.props.input.onChange(_this.state.relations);
      }

      if (_this.props.onChange != null && typeof _this.props.onChange == 'function') {
        _this.props.onChange(_this.state.relations);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          input = _this$props.input,
          sections = _this$props.sections;
      var user = new User(_this.props.user);
      var edit = false;

      if (_this.props.input) {
        if (input.value && input.value.length > 0) {
          edit = true;
          var clonedSections = JSON.parse(JSON.stringify(sections));
          clonedSections.forEach(function (section) {
            var relation = input.value.find(function (t) {
              return t.referenceId == section.id && t.referenceType == 'SECTION';
            });

            if (relation != null) {
              section.checked = true;
            } else {
              var userRelation = input.value.find(function (t) {
                return t.parentId == section.id && t.parentType == 'SECTION';
              });

              if (userRelation != null) {
                section.checked = false;
              }
            }
          });

          _this.setState({
            relations: input.value,
            sections: clonedSections
          }, function () {
            _this.onChange();
          });
        }
      }

      if (edit == false) {
        _this.setState({
          sections: JSON.parse(JSON.stringify(sections))
        }, function () {
          _this.onChange();
        });
      }

      if (user.isAdministrator() || user.isSchoolLeader()) {
        if (_this.props.showUsersWithoutMentorGroups) {
          _this.props.getUsersWithoutMentorGroups();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isFetching", function () {
      var fetching = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (_this.props.setIsLoading != null && typeof _this.props.setIsLoading == 'function') {
        _this.setState({
          isLoading: fetching
        });

        _this.props.setIsLoading(fetching);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMyGroups", function (checked) {
      _this.setState({
        myGroups: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAll", function () {
      var sections = _this.state.sections;

      var foundSectionRelations = _toConsumableArray(_this.state.relations).filter(function (relation) {
        return relation.referenceType == 'SECTION';
      });

      if (foundSectionRelations.length != _this.state.sections.length) {
        var relations = [];

        if (_this.props.alwaysFetchStudents) {
          sections.forEach(function (section) {
            if (_this.state.myGroups) {
              if (section.userRole != 'OWNER') {
                return false;
              }
            }

            if (!_this.state.educationGroups) {
              if (section.type == 'EDUCATION_GROUP') {
                return false;
              }
            }

            if (!_this.state.mentorGroups) {
              if (section.type == 'MENTOR_GROUP') {
                return false;
              }
            }

            section.checked = true;
            return section;
          });

          _this.setState({
            relations: relations,
            sections: sections
          }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var mapSeries;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    mapSeries = /*#__PURE__*/function () {
                      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iterable, action) {
                        var _iterator, _step, x;

                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _iterator = _createForOfIteratorHelper(iterable);
                                _context.prev = 1;

                                _iterator.s();

                              case 3:
                                if ((_step = _iterator.n()).done) {
                                  _context.next = 9;
                                  break;
                                }

                                x = _step.value;
                                _context.next = 7;
                                return action(x, true);

                              case 7:
                                _context.next = 3;
                                break;

                              case 9:
                                _context.next = 14;
                                break;

                              case 11:
                                _context.prev = 11;
                                _context.t0 = _context["catch"](1);

                                _iterator.e(_context.t0);

                              case 14:
                                _context.prev = 14;

                                _iterator.f();

                                return _context.finish(14);

                              case 17:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, null, [[1, 11, 14, 17]]);
                      }));

                      return function mapSeries(_x, _x2) {
                        return _ref2.apply(this, arguments);
                      };
                    }();

                    _context2.next = 3;
                    return _this.toggleStudentsWithoutMentorGroup(true);

                  case 3:
                    mapSeries(sections, _this.onSectionCheckboxClick);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
        } else {
          sections.forEach(function (section) {
            if (_this.state.myGroups) {
              if (section.userRole != 'OWNER') {
                return false;
              }
            }

            if (!_this.state.educationGroups) {
              if (section.type == 'EDUCATION_GROUP') {
                return false;
              }
            }

            if (!_this.state.mentorGroups) {
              if (section.type == 'MENTOR_GROUP') {
                return false;
              }
            }

            section.checked = true;
            relations.unshift({
              id: -1,
              referenceId: section.id,
              referenceType: 'SECTION',
              section: section
            });
          });

          _this.setState({
            relations: relations,
            sections: sections
          }, function () {
            _this.toggleStudentsWithoutMentorGroup(true);
          });
        }
      } else {
        sections.forEach(function (section) {
          section.checked = false;

          if (section.students != null) {
            section.students.forEach(function (student) {
              student.checked = false;
              return student;
            });
          }

          return section;
        });

        if (_this.props.usersWithoutMentorGroups != null) {
          _this.props.usersWithoutMentorGroups.forEach(function (user) {
            user.checked = false;
          });
        }

        _this.setState({
          relations: [],
          sections: sections
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSchool", function (school) {
      school.checked = !school.checked;

      var relations = _toConsumableArray(_this.state.relations);

      var relation = relations.findIndex(function (t) {
        return t.referenceId == school.id && t.referenceType == 'SCHOOL';
      });

      if (relation == -1) {
        relations.push({
          id: -1,
          referenceId: school.id,
          referenceType: 'SCHOOL'
        });
      } else {
        relations.splice(relation, 1);
      }

      _this.setState({
        relations: relations
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionCheckboxClick", function (section) {
      var forceActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
          var relations, relation;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  section.checked = !section.checked;

                  if (forceActive) {
                    section.checked = true;
                  }

                  relations = _toConsumableArray(_this.state.relations);

                  if (!section.checked) {
                    _context3.next = 14;
                    break;
                  }

                  relation = relations.find(function (t) {
                    return t.referenceId == section.id && t.referenceType == 'SECTION';
                  });

                  if (relation == null) {
                    //Add checked section
                    relations.unshift({
                      id: -1,
                      referenceId: section.id,
                      referenceType: 'SECTION',
                      section: section
                    });

                    if (section.students != null) {
                      section.students.forEach(function (student) {
                        var studentRelation = relations.find(function (t) {
                          return t.referenceId == student.id && t.referenceType == 'USER' && t.parentId == section.id && t.parentType == 'SECTION';
                        });

                        if (studentRelation == null) {
                          // Student doesnt have relation, add it
                          var _relation = {
                            id: -1,
                            referenceId: student.id,
                            referenceType: 'USER',
                            parentId: section.id,
                            parentType: 'SECTION'
                          };

                          if (student.mobilePhone != null) {
                            _relation.mobilePhone = student.mobilePhone;
                          }

                          relations.push(_relation);
                        }

                        student.checked = true;
                      });
                    }
                  }

                  if (!(_this.props.alwaysFetchStudents && section.students == null)) {
                    _context3.next = 11;
                    break;
                  }

                  section.loading = true;

                  _this.isFetching(true);

                  _this.props.getSection(section.id).then(function () {
                    _this.isFetching(false);

                    section.students = _this.props.group.students;

                    if (_this.state.relations.find(function (t) {
                      return t.referenceId == section.id && t.referenceType == 'SECTION';
                    }) != null) {
                      if (section.students != null) {
                        section.students.forEach(function (student) {
                          return student.checked = true;
                        });
                      }
                    }

                    if (section.students != null) {
                      section.students.forEach(function (student) {
                        var relation = relations.find(function (t) {
                          return t.referenceId == student.id && t.referenceType == 'USER' && t.parentId == section.id && t.parentType == 'SECTION';
                        });

                        if (relation != null) {
                          student.checked = true;
                        } else {
                          if (section.checked) {
                            var _relation2 = {
                              id: -1,
                              referenceId: student.id,
                              referenceType: 'USER',
                              parentId: section.id,
                              parentType: 'SECTION',
                              student: student
                            };

                            if (student.mobilePhone != null) {
                              _relation2.mobilePhone = student.mobilePhone;
                            }

                            student.checked = true;
                            relations = [].concat(_toConsumableArray(relations), [_relation2]);
                          }
                        }
                      });
                    }

                    section.loading = false;

                    _this.setState({
                      relations: relations
                    }, function () {
                      _this.onChange();

                      resolve(1);
                    });
                  });

                  return _context3.abrupt("return", true);

                case 11:
                  _this.setState({
                    relations: relations
                  }, function () {
                    _this.onChange();

                    resolve(1);
                  });

                  _context3.next = 18;
                  break;

                case 14:
                  // Remove section relationship
                  relations = _toConsumableArray(relations.filter(function (t) {
                    return (t.referenceId == section.id && t.referenceType == 'SECTION') == true ? false : true;
                  })); // Remove all user relations on this section

                  relations = _toConsumableArray(relations.filter(function (t) {
                    return (t.parentId == section.id && t.referenceType == 'USER') == true ? false : true;
                  })); // Set all students to unchecked

                  if (section.students != null) {
                    section.students.forEach(function (student) {
                      return student.checked = false;
                    });
                  }

                  section.checked = false;

                case 18:
                  _this.setState({
                    relations: relations
                  }, function () {
                    _this.onChange();

                    resolve(1);
                  });

                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSubmit", function (values) {
      return new Promise(function (resolve) {
        var _this$state = _this.state,
            sections = _this$state.sections,
            relations = _this$state.relations;
        var mobilePhone = values.mobilePhone == '' || values.mobilePhone == null ? null : values.mobilePhone;

        _this.props.updateUserPhoneNumber(values).then(function () {
          resolve(1);
          sections.map(function (section) {
            if (section.students != null) {
              section.students.map(function (student) {
                if (student.id == values.id) {
                  student.mobilePhone = mobilePhone;
                }

                return student;
              });
            }

            return section;
          });
          relations.map(function (relation) {
            if (relation.referenceId == values.id) {
              relation.mobilePhone = mobilePhone;
            }

            return relation;
          });

          _this.setState({
            sections: sections,
            relations: relations,
            editStudent: null
          }, function () {
            var user = new User(_this.props.user);

            if (user.isAdministrator() || user.isSchoolLeader()) {
              if (_this.props.showUsersWithoutMentorGroups) {
                _this.props.getUsersWithoutMentorGroups();
              }
            }

            _this.onChange();
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUserCheckboxClick", function (user, section) {
      user.checked = !user.checked;

      var relations = _toConsumableArray(_this.state.relations);

      if (user.checked) {
        var relation = relations.find(function (t) {
          return t.referenceId == user.id && t.referenceType == 'USER' && t.parentId == section.id && t.parentType == 'SECTION';
        });

        if (relation == null) {
          //Add checked user
          section.checked = false;
          var _relation3 = {
            id: -1,
            referenceId: user.id,
            referenceType: 'USER',
            parentId: section.id,
            parentType: 'SECTION',
            student: user
          };

          if (user.mobilePhone != null) {
            _relation3.mobilePhone = user.mobilePhone;
          }

          relations = [].concat(_toConsumableArray(relations), [_relation3]);
        }
      } else {
        //Removed unchecked user
        relations = _toConsumableArray(relations.filter(function (t) {
          return (t.referenceId == user.id && t.referenceType == 'USER' && t.parentId == section.id) == true ? false : true;
        }));
      }

      var sectionRelation = relations.find(function (t) {
        return t.referenceId == section.id && t.referenceType == 'SECTION';
      }); // Check if there is an unchecked student

      var uncheckedStudent = section.students.find(function (student) {
        return !student.checked;
      });

      if (sectionRelation != null) {
        // The current section has a reference
        if (uncheckedStudent != null) {
          // Remove section reference
          relations = _toConsumableArray(relations.filter(function (t) {
            return (t.referenceId == section.id && t.referenceType == 'SECTION') == true ? false : true;
          })); // Section is not checked because all students isnt selected

          section.checked = false;
        }
      } else {
        // The current section has no reference
        if (uncheckedStudent == null) {
          // Add section reference if no uncheckedStudent is found (all students checked)
          relations.unshift({
            id: -1,
            referenceId: section.id,
            referenceType: 'SECTION',
            section: section
          }); // Section is checked because all students is selected

          section.checked = true;
        }
      }

      _this.setState({
        relations: relations,
        section: section
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenSection", function (section) {
      section.open = !section.open;

      _this.setState({});

      if (!section.open || section.students != null) {
        return true;
      }

      section.loading = true;

      var relations = _toConsumableArray(_this.state.relations);

      _this.isFetching(true);

      _this.props.getSection(section.id).then(function () {
        _this.isFetching(false);

        section.students = _this.props.group.students;

        if (_this.state.relations.find(function (t) {
          return t.referenceId == section.id && t.referenceType == 'SECTION';
        }) != null) {
          if (section.students != null) {
            section.students.forEach(function (student) {
              return student.checked = true;
            });
          }
        }

        if (section.students != null) {
          section.students.forEach(function (student) {
            var relation = _this.state.relations.find(function (t) {
              return t.referenceId == student.id && t.referenceType == 'USER' && t.parentId == section.id && t.parentType == 'SECTION';
            });

            if (relation != null) {
              student.checked = true;
            } else {
              var _relation4 = {
                id: -1,
                referenceId: student.id,
                referenceType: 'USER',
                parentId: section.id,
                parentType: 'SECTION',
                student: student
              };

              if (student.mobilePhone != null) {
                _relation4.mobilePhone = student.mobilePhone;
              }

              if (section.checked) {
                relations = [].concat(_toConsumableArray(relations), [_relation4]);
              }
            }
          });
        }

        section.loading = false;

        _this.setState({
          relations: relations
        }, function () {
          _this.onChange();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentsWithoutMentorGroup", function (checked) {
      return new Promise(function (resolve) {
        // Remove or add relationships here
        var relations = _toConsumableArray(_this.state.relations);

        if (checked) {
          if (_this.props.usersWithoutMentorGroups != null) {
            _this.props.usersWithoutMentorGroups.forEach(function (user) {
              var foundRelation = _this.state.relations.findIndex(function (relation) {
                return relation.referenceId == user.userId;
              });

              if (foundRelation == -1) {
                user.checked = true;
                var relation = {
                  id: -1,
                  referenceId: user.userId,
                  referenceType: 'USER',
                  student: user
                };

                if (user.mobilePhone != null) {
                  relation.mobilePhone = user.mobilePhone;
                }

                relations = [].concat(_toConsumableArray(relations), [relation]);
              }
            });
          }
        } else {
          if (_this.props.usersWithoutMentorGroups != null) {
            _this.props.usersWithoutMentorGroups.forEach(function (user) {
              user.checked = false;
              relations = _toConsumableArray(relations.filter(function (t) {
                return !(t.referenceId == user.userId && t.referenceType == 'USER');
              }));
            });
          }
        }

        _this.setState({
          relations: relations
        }, function () {
          _this.onChange();

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentWithoutMentorGroup", function (user) {
      user.checked = !user.checked;

      var relations = _toConsumableArray(_this.state.relations);

      if (user.checked) {
        var relation = relations.find(function (t) {
          return t.referenceId == user.userId && t.referenceType == 'USER';
        });

        if (relation == null) {
          //Add checked user
          var _relation5 = {
            id: -1,
            referenceId: user.userId,
            referenceType: 'USER',
            student: user
          };

          if (user.mobilePhone != null) {
            _relation5.mobilePhone = user.mobilePhone;
          }

          relations = [].concat(_toConsumableArray(relations), [_relation5]);
        }
      } else {
        //Removed unchecked user
        relations = _toConsumableArray(relations.filter(function (t) {
          return !(t.referenceId == user.userId && t.referenceType == 'USER');
        }));
      }

      _this.setState({
        relations: relations
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderUsersWithoutMentorGroup", function () {
      if (_this.props.usersWithoutMentorGroups == null || _this.props.usersWithoutMentorGroups.length == 0) {
        return null;
      }

      var isAllChecked = true;

      _this.props.usersWithoutMentorGroups.forEach(function (user) {
        var foundRelation = _this.state.relations.findIndex(function (relation) {
          return relation.referenceId == user.userId;
        });

        if (foundRelation == -1) {
          isAllChecked = false;
        }
      });

      var title = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: _this.toggleStudentsWithoutMentorGroup,
        label: _this.props.translate('Students without mentor groups'),
        value: isAllChecked
      }));
      return /*#__PURE__*/React.createElement(Expandable, {
        title: title,
        ignorePropsUpdate: true,
        onClick: function onClick(toggle) {
          return false;
        },
        onPlus: function onPlus(toggle) {
          toggle();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "user-select-student-list"
      }, _this.props.usersWithoutMentorGroups.sort(function (a, b) {
        return (a.lastName || "").localeCompare(b.lastName || "");
      }).map(function (user) {
        var label = user.firstName + ' ' + (user.lastName || '');
        var checked = _this.state.relations.findIndex(function (relation) {
          return relation.referenceId == user.userId && relation.parentId == null;
        }) > -1;

        if (_this.props.showPhonenumbers) {
          label = /*#__PURE__*/React.createElement("div", {
            className: "df x"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, user.firstName, " ", user.lastName || ''), user.mobilePhone != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, user.mobilePhone.length > 4 && isValidPhoneNumber(user.mobilePhone) ? user.mobilePhone : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
            name: 'Alert_Red'
          }), _this.props.translate('Phone number invalid'))) : /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: 'Alert_Red'
          }), _this.props.translate('Phone number missing')), /*#__PURE__*/React.createElement("div", {
            onClick: function onClick(e) {
              return _this.onStudentEdit(e, user);
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Pen_Small"
          })));
        }

        return /*#__PURE__*/React.createElement("div", {
          key: user.userId
        }, /*#__PURE__*/React.createElement(Checkbox, {
          label: label,
          onChange: function onChange() {
            return _this.toggleStudentWithoutMentorGroup(user);
          },
          value: checked
        }));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentEdit", function (event, student) {
      event.stopPropagation();

      _this.setState({
        editStudent: student
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section) {
      if (_this.state.myGroups) {
        if (section.userRole != 'OWNER') {
          return null;
        }
      }

      if (!_this.state.educationGroups) {
        if (section.type == 'EDUCATION_GROUP') {
          return null;
        }
      }

      if (!_this.state.mentorGroups) {
        if (section.type == 'MENTOR_GROUP') {
          return null;
        }
      }

      var title = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        value: section.checked,
        onChange: function onChange() {
          return _this.onSectionCheckboxClick(section);
        },
        label: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/React.createElement("div", null, section.title), /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            margin: 0,
            marginLeft: '.55rem'
          }
        }, section.loading ? _this.props.translate('loading') + '...' : _this.props.translate(section.type)))
      }));
      return /*#__PURE__*/React.createElement(Expandable, {
        title: title,
        key: section.id,
        onPlus: function onPlus(toggle) {
          _this.onOpenSection(section);
        },
        onClick: function onClick(toggle) {
          return false;
        },
        open: section.open,
        headerStyles: {
          padding: '0 !important'
        }
      }, section.error ? /*#__PURE__*/React.createElement("div", {
        className: "section-error"
      }, section.error) : null, section.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, !section.loading ? /*#__PURE__*/React.createElement("div", {
        className: "user-select-student-list"
      }, section.students ? section.students.sort(function (a, b) {
        return (a.lastName || "").localeCompare(b.lastName || "");
      }).map(function (student) {
        var label = student.firstName + ' ' + (student.lastName || '');

        if (_this.props.showPhonenumbers) {
          label = /*#__PURE__*/React.createElement("div", {
            className: "df x"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, student.firstName, " ", student.lastName || ''), student.mobilePhone != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, student.mobilePhone.length > 4 && isValidPhoneNumber(student.mobilePhone) ? student.mobilePhone : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
            name: 'Alert_Red'
          }), _this.props.translate('Phone number invalid'))) : /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: 'Alert_Red'
          }), _this.props.translate('Phone number missing')), /*#__PURE__*/React.createElement("div", {
            onClick: function onClick(e) {
              return _this.onStudentEdit(e, student);
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Pen_Small"
          })));
        }

        return /*#__PURE__*/React.createElement("div", {
          key: student.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          onChange: function onChange() {
            return _this.onUserCheckboxClick(student, section);
          },
          value: student.checked,
          disabled: _this.props.userSelectDisabled,
          label: label
        }));
      }) : null) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSingleSchool", function () {
      var sections = _this.state.sections;

      if (_this.state.filter != '') {
        sections = _toConsumableArray(sections).filter(function (section) {
          return section.title.toLowerCase().indexOf(_this.state.filter.toLowerCase()) > -1;
        });
      }

      var foundSectionRelations = _toConsumableArray(_this.state.relations).filter(function (relation) {
        return relation.referenceType == 'SECTION';
      });

      var schoolSelected = foundSectionRelations.length == _this.state.sections.length;
      var school = new User(_this.props.user).getActiveSchool();
      var schoolTitle = /*#__PURE__*/React.createElement("div", null);

      if (school != null) {
        schoolTitle = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
          onChange: _this.toggleAll,
          label: school.title,
          value: schoolSelected,
          disabled: _this.state.isLoading
        }));
      }

      if (sections != null && sections.length == 0) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center',
            padding: '1.25rem 0',
            color: 'var(--color--meta)'
          }
        }, _this.props.translate('You have no connected groups. Contact your school administrator.'));
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: schoolTitle,
        open: true,
        ignorePropsUpdate: true,
        onClick: function onClick(toggle) {
          return false;
        },
        onPlus: function onPlus(toggle) {
          toggle();
        },
        headerStyles: {
          padding: '0px !important'
        }
      }, sections.map(function (section) {
        return _this.renderSection(section);
      }), _this.props.showUsersWithoutMentorGroups ? _this.renderUsersWithoutMentorGroup() : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSchool", function (school) {
      var checked = false;

      if (_this.state.relations.length > 0) {
        checked = _this.state.relations.find(function (t) {
          return t.referenceId == school.id && t.referenceType == 'SCHOOL';
        }) != null;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: school.id
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: school.title,
        onChange: function onChange() {
          return _this.toggleSchool(school);
        },
        value: checked
      }));
    });

    _this.state = {
      relations: [],
      sections: [],
      filter: '',
      myGroups: false,
      educationGroups: true,
      mentorGroups: true,
      editStudent: null,
      isLoading: false
    };
    return _this;
  }

  _createClass(UserSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      var user = new User(this.props.user);
      var schools = this.props.user.schools;
      schools = schools.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });

      if (this.props.selectMultipleSchools) {
        return /*#__PURE__*/React.createElement("div", {
          className: "user-select"
        }, /*#__PURE__*/React.createElement(BlockContent, {
          style: {
            position: 'relative',
            paddingTop: 0,
            paddingBottom: 0
          }
        }, schools.map(function (school) {
          return _this2.renderSchool(school);
        })));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "user-select"
      }, this.state.editStudent != null ? /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        title: translate('Edit phone number'),
        isOpen: true,
        onClose: function onClose() {
          return _this2.setState({
            editStudent: null
          });
        }
      }, /*#__PURE__*/React.createElement(UserPhoneForm, {
        user: this.state.editStudent,
        onCancel: function onCancel() {
          return _this2.setState({
            editStudent: null
          });
        },
        onSubmit: this.onStudentSubmit
      })) : null, /*#__PURE__*/React.createElement(BlockContent, {
        style: {
          position: 'relative',
          paddingTop: 0,
          paddingBottom: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(Search, {
        value: this.state.filter,
        onChange: function onChange(value) {
          return _this2.setState({
            filter: value
          });
        },
        placeholder: this.props.translate('Search group')
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.5rem'
        }
      })), this.renderSingleSchool(), user.isOperationManager() || user.isSchoolLeader() || user.isAdministrator() ? /*#__PURE__*/React.createElement("div", {
        className: "controls"
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
        className: "checkboxes"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('Mentor groups'),
        onChange: function onChange(c) {
          return _this2.setState({
            mentorGroups: c
          });
        },
        value: this.state.mentorGroups
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('Education groups'),
        onChange: function onChange(c) {
          return _this2.setState({
            educationGroups: c
          });
        },
        value: this.state.educationGroups
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('Show only my groups'),
        onChange: this.toggleMyGroups,
        value: this.state.myGroups
      }))) : null));
    }
  }]);

  return UserSelect;
}(Component);

_defineProperty(UserSelect, "defaultProps", {
  userSelectAllowed: true,
  multipleSectionsAllowed: true,
  maximumSectionsAllowed: 0,
  autoExpandSections: true,
  selectMultipleSchools: false,
  showUsersWithoutMentorGroups: false,
  showPhonenumbers: false,
  alwaysFetchStudents: false
});

function mapStateToProps(state) {
  return {
    user: state.user.currentUser,
    translate: translate(state.Languages.translations),
    group: state.sections.activeSection,
    usersWithoutMentorGroups: state.user.usersWithoutMentorGroups
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  getUsersWithoutMentorGroups: getUsersWithoutMentorGroups,
  updateUserPhoneNumber: updateUserPhoneNumber
})(UserSelect);